var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"340px","box-shadow":"0px 2px 9px 0px rgba(212,212,212,0.5)"},attrs:{"id":"shareholdingRatioEchart"}})}
var staticRenderFns = []

export { render, staticRenderFns }